'use strict';

const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './servicerequest-ticket-show.routes';

export class ServicerequestTicketShowComponent {
  constructor($state, $stateParams, dialogs, ServiceRequestTicketsService, $uibModal, $window, Auth, RecentVisits, PinnedItems,
              WorkOrderTicketsService, prompt) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.Auth = Auth;
    this.ticketId = $stateParams.id;
    this.prompt = prompt;
    this.$uibModal = $uibModal;
    this.tasks = [];
    this.activities = [];

    this.dialogs = dialogs;
    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
    this.WorkOrderTicketsService = WorkOrderTicketsService;
    this.RecentVisits = RecentVisits;
    this.PinnedItems = PinnedItems;

    this.cards = [];

    Auth.getCurrentUser(user => {
      this.user = user;
      this.userId = user._id;
    });

    this.$state = $state;

    this.refreshData();
  }

  getPathPhoto(idx) {
    let _idx = (idx) ? idx - 1 : 0;
    return "/api/storage/" + this.cards[_idx];
  }

  refreshData() {
    if (this.ticketId) {
      this.cards = [];
      this.ServiceRequestTicketsService.get({id: this.ticketId}, data => {
        this.ticket = data;

        this.RecentVisits.addWorkItem(this.ticketId, "sr", `${this.ticket.code}: ${this.ticket.name}`);
        this.isPinned = this.PinnedItems.isPinnedWorkItem(this.ticketId);

        this.cards = this.ticket.attachments
          .filter(att => att.contentType.startsWith('image/'))
          .map(att => att._id);

        if (this.ticket.property)
          this.cards.unshift(null); // the user-card
      }, err => {
        console.log('Could not load service request ticket from server');
      });
    }
  }

  propertyAssign() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (property) {
        that.ticket.property = property._id;
        that.ServiceRequestTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }

  changeState() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'stateChangeForm',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (stateChange) {
        that.ticket.status = stateChange.status;

        if (stateChange.reason) {
          that.ticket.notes.push({
            meta: {
              creationUser: that.Auth.getCurrentUserSync()._id
            },
            note: "Changed the state to '" + stateChange.status + "' because: " + stateChange.reason
          })
        }

        if (stateChange.status == 'open') { // it was closed
          delete that.ticket.closeDate;     // then remove close date
        } else {
          that.ticket.closeDate = new Date(); // otherwise now it is closed
        }

        that.ServiceRequestTicketsService.update({id: that.ticketId}, that.ticket, _ => that.refreshData());
      },
      function () { /* cancel */ }
    );

  }

  createWorkOrder() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'serviceRequestToWorkorderForm',
      resolve: {
        config: function() {
          return {
            data: that.ticket
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (workOrderSettings) {

        let workOrder = angular.copy(that.ticket);

        delete workOrder._id;
        delete workOrder.customFields;
        delete workOrder.attachments;
        delete workOrder.requester;

        workOrder.meta = {
          creationUser: that.Auth.getCurrentUserSync()._id
        };

        workOrder.code = workOrderSettings.code;
        workOrder.status = "open";
        workOrder.notes = [{
          note: "Created from Service Request <a href='/servicerequest/ticket/detail/"+that.ticketId+"'>"+ that.ticket.code + ": " + that.ticket.name +"</a>",
          meta: {
            creationUser: that.Auth.getCurrentUserSync()._id
          }
        }];

        that.WorkOrderTicketsService.save(workOrder, _=> {}, err => { console.log(err) });

        /* --- */

        let patchObject = [];

        if (workOrderSettings.close) {
          patchObject.push({ "op": "replace", "path": "/status", "value": "closed" });
        }

        if (workOrderSettings.note) {
          let noteObj = {
            firstName: that.user.firstName,
            middleName: that.user.middleName,
            lastName: that.user.lastName,
            meta: {
              suiteUser: that.userId
            },
            note: workOrderSettings.note
          };
          patchObject.push({ "op": "add", "path": "/chat/-", "value": noteObj });
        }

        if (patchObject.length) {
          that.ServiceRequestTicketsService.patch({id: that.ticketId}, patchObject, data => {
            that.refreshData()
          });
        }
      },
      function () { /* cancel */ }
    );

  }

  addMessage() {
    this.prompt({
      title: 'Add Message for Owner',
      message: 'Add your message below',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let msgObj = {
        note: note,
        firstName: this.user.firstName,
        middleName: this.user.middleName,
        lastName: this.user.lastName,
        meta: {
          suiteUser: this.userId
        }
      };

      this.ServiceRequestTicketsService.patch({id: this.ticketId}, [
        { "op": "add", "path": "/chat/-", "value": msgObj },
      ], data => {
        this.refreshData();
      });
    });
  }

  openAssetUploadModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(resultIds => {
        that.ServiceRequestTicketsService.addAttachments({id: that.ticketId}, resultIds, _ => {
          that.refreshData();
        }, err => {
          console.log('could not add attachments to ticket');
        });
      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduu.serviceRequestTicketShow', [uiRouter])
  .config(routes)
  .component('serviceRequestTicketShow', {
    template: require('./servicerequest-ticket-show.html'),
    controller: ServicerequestTicketShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/servicerequests/ticket-show/servicerequest-ticket-show.component.js